const getDefaultStateTessereEsports = () => {
  return {
    stagioneEconomatoTessereEsports: null,
    idComitatoRegionaleTessereEsports: null,
    dataEmissioneDaTessereEsports: null,
    dataEmissioneATessereEsports: null,
    dataApprovazioneDaTessereEsports: null,
    dataApprovazioneATessereEsports: null,
    idTesseratoTessereEsports: null,
    nomeTesseratoTessereEsports: "",
    nomeSocietaTessereEsports: "",
    idSocietaTessereEsports: null,
    tipoPagamentoTessereEsports: null,
    approvatoTessereEsports: null,
    meseTessereEsports: null,
    rowsToSkipTessereEsports: 0,
    fetchRowsTessereEsports: 25,
    currentPageTessereEsports: 1,
    sortColumnTessereEsports: "numero",
    sortOrderTessereEsports: "desc",
  };
};
const state = getDefaultStateTessereEsports();

const getters = {
  stagioneEconomatoTessereEsports: (state) =>
    state.stagioneEconomatoTessereEsports,
  idComitatoRegionaleTessereEsports: (state) =>
    state.idComitatoRegionaleTessereEsports,
  dataEmissioneDaTessereEsports: (state) => state.dataEmissioneDaTessereEsports,
  dataEmissioneATessereEsports: (state) => state.dataEmissioneATessereEsports,
  dataApprovazioneDaTessereEsports: (state) =>
    state.dataApprovazioneDaTessereEsports,
  dataApprovazioneATessereEsports: (state) =>
    state.dataApprovazioneATessereEsports,
  idTesseratoTessereEsports: (state) => state.idTesseratoTessereEsports,
  nomeTesseratoTessereEsports: (state) => state.nomeTesseratoTessereEsports,
  nomeSocietaTessereEsports: (state) => state.nomeSocietaTessereEsports,
  idSocietaTessereEsports: (state) => state.idSocietaTessereEsports,
  tipoPagamentoTessereEsports: (state) => state.tipoPagamentoTessereEsports,
  approvatoTessereEsports: (state) => state.approvatoTessereEsports,
  meseTessereEsports: (state) => state.meseTessereEsports,
  rowsToSkipTessereEsports: (state) => state.rowsToSkipTessereEsports,
  fetchRowsTessereEsports: (state) => state.fetchRowsTessereEsports,
  currentPageTessereEsports: (state) => state.currentPageTessereEsports,
  sortColumnTessereEsports: (state) => state.sortColumnTessereEsports,
  sortOrderTessereEsports: (state) => state.sortOrderTessereEsports,
};

// const actions = {};
const mutations = {
  setNomeTesseratoTessereEsports: (state, value) => {
    state.nomeTesseratoTessereEsports = value ? value : null;
  },
  setNomeSocietaTessereEsports: (state, value) => {
    state.nomeSocietaTessereEsports = value ? value : null;
  },
  setIdComitatoRegionaleTessereEsports: (state, value) => {
    state.idComitatoRegionaleTessereEsports = value;
  },
  setDataEmissioneDaTessereEsports: (state, value) => {
    state.dataEmissioneDaTessereEsports = value;
  },
  setDataEmissioneATessereEsports: (state, value) => {
    state.dataEmissioneATessereEsports = value;
  },
  setDataApprovazioneDaTessereEsports: (state, value) => {
    state.dataApprovazioneDaTessereEsports = value;
  },
  setDataApprovazioneATessereEsports: (state, value) => {
    state.dataApprovazioneATessereEsports = value;
  },
  setTesseratoTessereEsports: (state, value) => {
    state.idTesseratoTessereEsports = value ? value.value : null;
    state.nomeTesseratoTessereEsports = value ? value.name : null;
  },
  setSocietaTessereEsports: (state, value) => {
    state.idSocietaTessereEsports = value ? value.value : null;
    state.nomeSocietaTessereEsports = value ? value.name : null;
  },
  setTipoPagamentoTessereEsports: (state, value) => {
    state.tipoPagamentoTessereEsports = value;
  },
  setApprovatoTessereEsports: (state, value) => {
    state.approvatoTessereEsports = value;
  },
  setMeseTessereEsports: (state, value) => {
    state.meseTessereEsports = value;
  },
  setFetchRowsTessereEsports: (state, value) => {
    state.currentPageTessereEsports = 1;
    state.rowsToSkipTessereEsports = 0;
    state.fetchRowsTessereEsports = value;
  },
  setCurrentPageTessereEsports: (state, value) => {
    state.currentPageTessereEsports = value;
    state.rowsToSkipTessereEsports = parseInt(
      (state.currentPageTessereEsports - 1) * state.fetchRowsTessereEsports
    );
  },
  setSortColumnTessereEsports: (state, value) => {
    state.sortColumnTessereEsports = value;
  },
  setSortOrderTessereEsports: (state, value) => {
    state.sortOrderTessereEsports = value;
  },
  setCategoriaTesseraTessereEsports: (state, value) => {
    state.id_categoriaTessereEsports = value;
  },
  resetFiltersTessereEsports: (state) => {
    Object.assign(state, getDefaultStateTessereEsports());
  },
  resetRowsToSkipTessereEsports: (state) => {
    state.currentPageTessereEsports = 1;
    state.rowsToSkipTessereEsports = 0;
  },
};

export default {
  state,
  getters,
  mutations,
};
